import { Flex, Loader, Text } from "@mantine/core";
import { openModal } from "@mantine/modals";
import { ReactNode } from "react";
import { ModalId, fullScreenModalCss } from "src/utils/constants";

export default function useReport() {
  const openDownloadModal = (title: string) => {
    openModal({
      closeOnClickOutside: false,
      title,
      children: (
        <Flex
          direction={"column"}
          gap={"md"}
          justify={"center"}
          align={"center"}
        >
          <Loader />
          <Text fw={"bold"} size={"lg"}>
            Download Pending...
          </Text>
        </Flex>
      ),
    });
  };

  const handleReportView = (children: ReactNode) => {
    openModal({
      modalId: ModalId.ReportView,
      fullScreen: true,
      children,
      styles: {
        ...fullScreenModalCss,
      },
      sx: {
        ".mantine-Grid-root": {
          height: "100%  !important",
        },
        ".mantine-Modal-body": {
          height:
            "calc(100% - (var(--mantine-footer-height, 0px)) ) !important",
          overflow: "auto",
        },
      },
    });
  };

  return {
    openDownloadModal,
    handleReportView,
  };
}
